export const getIframeSize = (): { width: string; height: string } => {
  const div = document.createElement('div');
  div.style.position = 'fixed';
  div.style.zIndex = '-9999';
  div.style.width = '100%';
  div.style.height = '100%';
  div.style.opacity = '0';
  div.innerHTML = '&#8203;';
  document.body.appendChild(div);
  const boundingClientRect = div.getBoundingClientRect();
  const result = {
    width: `${boundingClientRect.width}px`,
    height: `${boundingClientRect.height}px`,
  };
  document.body.removeChild(div);
  return result;
};
